module.exports = __webpack_public_path__ + "img/T&C.177bd9cb.png";